import { render } from "./ui-table-header.vue?vue&type=template&id=0d543094&ts=true"
import script from "./ui-table-header.vue?vue&type=script&lang=ts"
export * from "./ui-table-header.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__